import { WidgetsLoginMain } from '@/widgets/login';

export const PagesLoginMain = () => <WidgetsLoginMain />;
